import { Icon } from '@iconify/react';
import InfoIcon from '@mui/icons-material/Info';
import {
  Button,
  Container,
  Grid,
  TableCell,
  TableRow,
  Tooltip,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import ErrorSpecific from 'ErrorSpecific';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ReactToPrint from 'react-to-print';
import api from 'services/api';
import { POND_STATUS_CYCLE } from 'utils/consts';
import styleGlobal from '../../../Global.module.css';
import Progress from '../../../components/Progress';
import ReportContainer from '../../../components/ReportComponent/ReportContainer';
import ReportTable from '../graphs/components/ReportComponent/ReportTable';
import ReportDetails from './ReportComponent/ReportDetails';
import './styles.css';

export default function ReportProduction() {
  const history = useHistory();
  const [dataReport, setDataReport] = useState([]);
  const selectedCycle = useSelector(
    (state) => state.selectedCycle.selectedCycle
  );
  const [dataReportIsNull, setDataReportIsNull] = useState(false);
  const [dataLoading, setDataLoading] = useState(true);
  const columns = [
    {
      name: 'Insumo',
      field: 'name',
    },
    {
      name: 'Quantidade',
      field: 'quantity',
      align: 'center',
    },
    {
      name: 'Valor',
      field: 'value',
      align: 'center',
    },
    {
      name: 'Percentual',
      field: 'percent',
      align: 'center',
    },
  ];

  useEffect(() => {
    async function load() {
      // carrega o viveiro caso tenha id, do contrario carrega vazio para cadastrar um novo

      const request = await api.get('/reports/production', {
        params: { cycle_code_id: selectedCycle?.id },
      });
      if (request.data.length === 0) {
        setDataReportIsNull(false);
      } else {
        setDataReportIsNull(true);
        setDataReport(request.data);
      }
      setDataLoading(false);
    }
    load();
  }, [selectedCycle]);

  const componentRef = useRef();

  function updateColumns(i, columns) {
    const testePercent = dataReport[i].inputs?.filter(
      (input) => input.percent === 0
    );

    if (testePercent.length > 0) {
      return columns.filter((obj) => obj.name !== 'Percentual');
    }
    return columns;
  }

  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#FFFFFF',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 300,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #0367bf',
    },
  }))(Tooltip);

  return (
    <Grid container style={dataReportIsNull ? {} : { flexDirection: 'column' }}>
      {dataLoading ? <Progress /> : null}
      <Container
        style={{
          maxWidth: '1000%',
          backgroundColor: '#fff',
          marginTop: '1em',
          marginBottom: '1em',
          marginLeft: 'auto',
          width: '93%',
          height: '4rem',
          borderRadius: '20px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingInline: '2rem',
          boxShadow:
            '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
        }}
      >
        <h2 style={{ marginLeft: '0.7rem', marginTop: '1rem' }}>
          Relatório de Produção{' '}
          <HtmlTooltip
            title={
              <>
                Esse relatório tem o objetivo de detalhar os dados dos viveiros
                de um determinado ciclo, levando em consideração as fases de
                produção. Ex: berçário e engorda.
              </>
            }
            placement="right"
            arrow
            interactive
          >
            <InfoIcon color="primary" fontSize="inherit" />
          </HtmlTooltip>
        </h2>
        <ReactToPrint
          trigger={() => (
            <Button
              variant="outlined"
              style={{
                marginTop: '0.5rem',
                border: '1px solid #111',
                borderRadius: '10px',
                color: '#000',
                height: '2.5rem',
                width: '8rem',
              }}
            >
              Exportar
            </Button>
          )}
          content={() => componentRef.current}
          documentTitle="Relatorio de produção"
        />
      </Container>
      <div ref={componentRef} style={{ width: '100%' }}>
        {dataReportIsNull ? (
          dataReport.map((item, i) => {
            let titulo = item.pond || `Viveiro ${i + 1}`;
            titulo += ` ${item.pond_type ? `(${item.pond_type})` : ''}`;
            const testePercent = item.inputs.filter(
              (input) => input.percent === 0
            );

            return (
              <section className={styleGlobal.headerRelatorios}>
                <div className="page-break" />
                <ReportContainer key={i} title={titulo}>
                  {item?.status === POND_STATUS_CYCLE.PREPARANDO ? (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '25px',
                        marginBottom: '50px',
                      }}
                    >
                      <h2
                        style={{
                          fontWeight: 'normal',
                          margin: '2rem',
                          textAlign: 'center',
                        }}
                      >
                        Viveiro Em Preparação.{' '}
                        <a
                          style={{ color: '#0666C2', cursor: 'pointer' }}
                          onClick={() => history.push('/cycles')}
                        >
                          Clique aqui
                        </a>{' '}
                        para visualizar o viveiro.
                      </h2>
                    </div>
                  ) : (
                    <>
                      <ReportDetails details={item} />

                      {item?.inputs.length === 0 ? (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginBottom: '1rem',
                          }}
                        >
                          <h2 style={{ fontWeight: 'normal' }}>
                            Não existem lançamentos de consumo neste viveiro
                          </h2>
                        </div>
                      ) : (
                        <ReportTable
                          loading={dataLoading}
                          // callback={updateColumns}
                          columns={updateColumns(i, columns)}
                          style={{ width: '100vw' }}
                        >
                          {item?.inputs.map((index, j) => (
                            <TableRow
                              key={j}
                              style={{
                                backgroundColor:
                                  index.type === '1'
                                    ? 'rgba(0,102,0,0.08)'
                                    : index.type === '2'
                                    ? 'rgba(204,0,0,0.08)'
                                    : 'rgba(0,0,0,0.0)',
                                height: 'auto !important',
                                fontWeight: index.analytical
                                  ? 'bold'
                                  : 'normal',
                              }}
                            >
                              <TableCell
                                key={j}
                                align="left"
                                width="15%"
                                component="th"
                                scope="row"
                                sx={{
                                  '&.MuiTableCell-alignLeft': {
                                    // backgroundColor: 'red',
                                    pl: '8%',
                                  },
                                }}
                              >
                                {index.name}
                              </TableCell>
                              <TableCell
                                key={j}
                                align="center"
                                width="15%"
                                component="th"
                                scope="row"
                              >
                                {`${index.quantity} ${index.unity}`}
                              </TableCell>
                              <TableCell
                                key={j}
                                align="center"
                                width="15%"
                                component="th"
                                scope="row"
                              >
                                {index.value !== 0
                                  ? `R$ ${Intl.NumberFormat('pt-BR', {
                                      minimumFractionDigits: 2,
                                    }).format(index.value)}`
                                  : '-'}
                              </TableCell>
                              {updateColumns(i, columns).find(
                                (obj) => obj.name === 'Percentual'
                              ) === undefined ? null : (
                                <TableCell
                                  key={j}
                                  align="center"
                                  width="15%"
                                  component="th"
                                  scope="row"
                                >
                                  {index.percent !== null
                                    ? `${parseFloat(index.percent).toFixed(
                                        2
                                      )} %`
                                    : '-'}
                                </TableCell>
                              )}
                            </TableRow>
                          ))}
                          <TableRow>
                            <TableCell
                              key="todos"
                              align="left"
                              width="15%"
                              component="th"
                              scope="row"
                              sx={{
                                '&.MuiTableCell-alignLeft': {
                                  // backgroundColor: 'red',
                                  pl: '8%',
                                },
                              }}
                            >
                              <b>Todos</b>
                            </TableCell>
                            <TableCell
                              key="-"
                              align="center"
                              width="15%"
                              component="th"
                              scope="row"
                            >
                              -
                            </TableCell>
                            <TableCell
                              key="value"
                              align="center"
                              width="15%"
                              component="th"
                              scope="row"
                            >
                              <b>
                                {`R$ ${Intl.NumberFormat('pt-BR', {
                                  minimumFractionDigits: 2,
                                }).format(
                                  item?.inputs.reduce(
                                    (acc, cur) => acc + cur.value,
                                    0
                                  )
                                )}`}
                              </b>
                            </TableCell>
                            <TableCell
                              key="percent"
                              align="center"
                              width="15%"
                              component="th"
                              scope="row"
                            >
                              <b>{parseFloat(100).toFixed(2)} %</b>
                            </TableCell>
                          </TableRow>
                        </ReportTable>
                      )}
                    </>
                  )}
                </ReportContainer>
              </section>
            );
          })
        ) : (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '100px',
            }}
          >
            <h2 style={{ fontWeight: 'normal' }}>
              Dados insuficientes para gerar relatório
            </h2>
          </div>
        )}
      </div>
    </Grid>
  );
}
